import Vue from 'vue';
import CardCarousel from "./components/card-carousel";
import Offer from "./components/cards/offer";
import OfferPromo from "./components/cards/offer-promo";
import Lightbox from "./components/lightbox";
import Gallery from "./components/gallery";
import Itinerary from "./components/itinerary";
import ItineraryPromo from "./components/itinerary-promo";
import ItineraryExamples from "./components/itinerary-examples";

import ItinerarySimpleForm from "./components/forms/itinerary-simple-form";
import SectionFooter from "./layout/footer";
import SectionHeader from "./layout/header";
import SectionHeaderSmall from "./layout/header-small";
import SectionHeaderSmallForm from "./layout/header-small-form";
import SectionLowcySuperpromo from "./layout/lowcy-superpromo";
import SectionHeaderSmallPr from "./layout/header-small-pr";
import PasswordChange from './components/forms/password-change';

import SectionBreadcrumb from "./layout/breadcrumb";
import SectionSidebar from "./layout/sidebar";
import SectionSidebarPr from "./layout/sidebar-pr";
import SectionSearchTicketOffice from "./layout/search-ticket-office";
import TopMenu from "./layout/top-menu";
import SectionSidebarFilter from "./layout/sidebar-filter";
import SectionHeaderFormAdv from "./layout/header-form-adv";
import SectionFooterSimple from "./layout/footer-simple";


import { i18n, loadLanguageAsync } from '@/ic-common/i18n/i18n-setup'
import { loadLanguageFromChunk } from '@/ic-common/i18n/i18n-setup'


import Vuelidate from 'vuelidate'
import vuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import customFormGroup from '@/components/ic-common/form/helpers/FormRowWrapper'

import { VueReCaptcha } from 'vue-recaptcha-v3'

import KoloroweKarty from '@/components/ic/form/KoloroweKarty/KoloroweKarty'
import IcFormsComplaint from '@/components/ic/form/contact/FormsComplaint'
import IcForms from '@/components/ic/form/contact/Forms'
import IcFormOzn from './components/ic/form/ozn/FormOzn.vue'
import IcFormsContact from '@/components/ic/form/contact/FormsContact'
import IcFormsMikol from '@/components/ic/form/contact/FormsMikol'
import IcFormsZamownienieWagonu from '@/components/ic/form/contact/FormsZamowienieWagonu'
import ItineraryAdvForm from "./components/forms/itinerary-adv-form-module";
import ItineraryOznForm from "./components/forms/itinerary-ozn-form-module";
import DateTime from './components/forms/inputs/date-time';
import SocialPosts from './layout/social-posts';
var axios = require('axios')
import moment from 'moment'
import ResetInput from 'v-reset-input'

/* Polyfills */

require('es6-promise').polyfill()
var axios = require('axios')
require('jspolyfill-array.prototype.find')

window.$ = window.jQuery = require('jquery');
//require('bootstrap');


/* Config */

// Vue.config.productionTip = false
// Vue.config.performance = true
// Vue.config.silent = false
// Vue.config.devtools = true
// Vue.config.debug = true
   
Vue.config.productionTip = false
Vue.config.performance = true
Vue.config.silent = true
Vue.config.devtools = false
Vue.config.debug = false
   


/* Vuelidate */
const vuelidateErrorExtractorConfig = {
  template: customFormGroup,
  // template: templates.singleErrorExtractor.bootstrap5
  name: 'IcFormRowWrapper',
  i18n: 'validation'
}

Vue.use(vuelidateErrorExtractor, vuelidateErrorExtractorConfig)
Vue.component('FormWrapper', templates.FormWrapper)
Vue.use(Vuelidate)

axios.defaults.withCredentials = true

Vue.use(VueReCaptcha, { siteKey: "6LcNU6YUAAAAAMo0TeD0AX_xkFr_JY3OiNEC_QDs"})

Vue.use(ResetInput)

const bus = new Vue()
Vue.prototype.$bus = bus;

//var app = null;


   
Vue.prototype.moment = moment





window.onload = function () {

    Promise.all([
      loadLanguageFromChunk(i18n.locale, 'default'),
      loadLanguageAsync(i18n.locale, true, '/ax26hrxl857-a/components/icformozn/connector.php?action=getlanguage&cultureKey='+siteLang),
      loadLanguageFromChunk(i18n.locale, 'validation', true).then(
        msgs => (vuelidateErrorExtractorConfig.messages = msgs)
      )
    ]).then(() => {

         window.app = new Vue({ 
            i18n,   
            data: {
              
            },
            mounted() {
              this.$nextTick(function () {
                  new classCore();

                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                    return new bootstrap.Tooltip(tooltipTriggerEl)
                })
                var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
                var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
                    return new bootstrap.Popover(popoverTriggerEl)
                })
                // var collapseElementList = [].slice.call(document.querySelectorAll('[data-bs-toggle="collapse"]'))
                // var collapseList = collapseElementList.map(function (collapseEl) {
                //     return new bootstrap.Collapse(collapseEl)
                // })
                
                if (window.innerWidth > 992) {

                    document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){

                        everyitem.addEventListener('mouseover', function(e){

                            let el_link = this.querySelector('a[data-bs-toggle]');

                            if(el_link != null){
                                let nextEl = el_link.nextElementSibling;
                                el_link.classList.add('show');
                                nextEl.classList.add('show');
                            }

                        });
                        everyitem.addEventListener('mouseleave', function(e){
                            let el_link = this.querySelector('a[data-bs-toggle]');

                            if(el_link != null){
                                let nextEl = el_link.nextElementSibling;
                                el_link.classList.remove('show');
                                nextEl.classList.remove('show');
                            }


                        })
                    });

                }                
                  
                  })
            },
            components: {
                CardCarousel,
                Offer,
                OfferPromo,
                SectionFooter,
                SectionFooterSimple,
                SectionHeader,
                SectionHeaderSmall,
                SectionHeaderSmallForm,
                SectionBreadcrumb,
                SectionSidebar,
                SectionSidebarPr,
                SectionSearchTicketOffice,
                TopMenu,
                Lightbox,
                Gallery,
                DateTime,
                Itinerary,
                ItineraryPromo,
                SectionSidebarFilter,
                ItineraryExamples,
                ItinerarySimpleForm,
                PasswordChange,
                SectionHeaderFormAdv,
                SectionHeaderSmallPr,
                KoloroweKarty,
                IcForms,
                IcFormsComplaint,
                IcFormOzn,
                IcFormsContact,
                IcFormsMikol,
                IcFormsZamownienieWagonu,
                ItineraryAdvForm,
                ItineraryOznForm,
                SectionLowcySuperpromo,
                SocialPosts
            },
             methods: {
                 showTicketSearch: function () {
                     //console.log("clicked");
                     this.$bus.$emit('show-ticket-search', 1);
                 },
                 renderSearchResults: function () {
                    //console.log("clicked");
                    this.$bus.$emit('show-ticket-search', 1);
                },
                lowcySort: function (data) {
                    this.$bus.$emit('search-lowcy', data);
                },
                lowcyPage: function (data) {
                    this.$bus.$emit('page-lowcy', data);
                },
                stationChange: function (data) {
                    this.$bus.$emit('station-change', data);
                }

             },

         }).$mount('#app');
    })

    
}